import React from 'react'
import styled from 'styled-components'
import { Flex } from 'reflexbox/styled-components'

import theme from 'theme'
import media from 'media'

const FlexContainer = styled(Flex).attrs({
  flexDirection: ['column', 'column', 'row'],
})`
  gap: 30px;
`

const ItemContainer = styled(Flex).attrs({
  width: [1],
  flexDirection: ['row', 'row', 'column'],
})``

const ItemContent = styled(Flex).attrs({
  flexDirection: ['column'],
})`
  margin-left: 24px;
  flex: 1;
  ${media.desktop`
     margin-left: 0;
`}
`

const ItemTitle = styled.div`
  font-size: ${theme.fontSizes[60]}px;
  font-weight: ${theme.fontWeights.bold};
  margin-bottom: 6px;

  ${media.desktop`
    font-size: ${theme.fontSizes[120]}px;
    margin-top: 12px;
    margin-bottom: 12px;
  `}
`

const DescriptionContainer = styled.div``

const ItemDescription = styled.div`
  margin-bottom: 6px;
  ${media.desktop`
    margin-bottom: 12px;
  `}
`

export default function SimpleValueProps ({ items, ...others }) {
  return (
    <FlexContainer {...others}>
      {items.map(({ icon, title, description, renderCTA }, index) => (
        <ItemContainer key={title}>
          {icon}
          <ItemContent>
            <ItemTitle>{title}</ItemTitle>
            <DescriptionContainer>
              <ItemDescription>{description}</ItemDescription>
              {renderCTA && renderCTA()}
            </DescriptionContainer>
          </ItemContent>
        </ItemContainer>
      ))}
    </FlexContainer>
  )
}
